// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"b1ebf5db","410":"80a804ea"}[chunkId] + ".chunk.css";
};